import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function SolutionSection() {
  const features = ['Diseño moderno optimizado para móviles', 'Botones de reserva o contacto', 'Integración con WhatsApp', 'Diseño enfocado en convertir visitas en clientes', 'Presencia profesional online'];
  return <section className="py-20 bg-dark text-white relative overflow-hidden" data-id="element-157">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-158">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-primary/20 blur-[120px]" data-id="element-159"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-accent/10 blur-[120px]" data-id="element-160"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-161">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-162">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-163">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-164">
              La web diseñada para{' '}
              <span className="text-primary" data-id="element-165">atraer clientes</span>
            </h2>
            <p className="text-lg text-gray-300 mb-6 leading-relaxed" data-id="element-166">
              Webs modernas creadas con inteligencia artificial para atraer
              clientes y reservas.
            </p>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-167">
              Utilizamos inteligencia artificial para crear webs profesionales
              más rápido y ofrecer precios accesibles.
            </p>

            <a href="#boton-compra-297" className="inline-flex items-center justify-center bg-primary hover:bg-blue-600 text-white px-8 py-3 rounded-full font-semibold transition-colors" data-id="element-168">
              Saber más
            </a>
          </motion.div>

          <motion.div className="bg-white/5 border border-white/10 rounded-2xl p-8 backdrop-blur-sm" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-169">
            <h3 className="text-xl font-semibold mb-6 text-white" data-id="element-170">
              Cada web incluye:
            </h3>
            <ul className="space-y-4" data-id="element-171">
              {features.map((feature, index) => <motion.li key={index} className="flex items-start gap-3" initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: 0.3 + index * 0.1
            }} data-id="element-172">
                  <CheckCircle2Icon className="w-6 h-6 text-accent flex-shrink-0 mt-0.5" data-id="element-173" />
                  <span className="text-gray-200 text-lg" data-id="element-174">{feature}</span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}